// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M17.759 2H2.00088V17.7582L10.0871 9.67197L9.00088 8.58579L4.00088 13.5858V4H15.759L17.759 2Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M0.583008 22.0045L21.9931 0.594389L21.9888 0.590088L21.9929 0.585938L23.4071 2.00015L22.0009 3.4064V22H3.40728L1.99292 23.4144L0.583008 22.0045ZM16.0009 10.75C15.6058 10.75 15.2302 10.6667 14.8906 10.5167L12.9112 12.4961L20.0009 19.5858V5.4064L18.5175 6.88973C18.6676 7.22929 18.7509 7.60492 18.7509 8C18.7509 9.51878 17.5197 10.75 16.0009 10.75Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-image-off-filled')
export default class ImageOffFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'image-off-filled',
    }
  }
}
